import { useState } from 'react';

export const useGlobalVar = () => {
    const [providerVar, setProviderVar] = useState("");

    return { providerVar, setProviderVar };
};